import { ISeparatorProps, Separator } from '@fluentui/react/lib/Separator';

export interface IPSeparatorProps extends ISeparatorProps {}

export const IPSeparator = (props: IPSeparatorProps) => {
  return <Separator {...props} />;
};
